import { ComparisonOperators } from './comparison-operators';
export var SamePageViewBehaviors;
(function (SamePageViewBehaviors) {
    SamePageViewBehaviors["interactionEvents"] = "interactionEvents";
    SamePageViewBehaviors["zoneMetrics"] = "zoneMetrics";
    SamePageViewBehaviors["zoneInsights"] = "zoneInsights";
    SamePageViewBehaviors["pageviewMetrics"] = "pageviewMetrics";
    SamePageViewBehaviors["errors"] = "errors";
    SamePageViewBehaviors["textConditions"] = "textConditions";
    SamePageViewBehaviors["pageEvents"] = "pageEvents";
    SamePageViewBehaviors["webVitals"] = "webVitals";
})(SamePageViewBehaviors || (SamePageViewBehaviors = {}));
export var FovFieldTypes;
(function (FovFieldTypes) {
    FovFieldTypes["Pageviews"] = "pageviews";
    FovFieldTypes["Goal"] = "goal";
    FovFieldTypes["GoalId"] = "goal:id";
    FovFieldTypes["GoalReference"] = "goal:reference";
    FovFieldTypes["SegmentId"] = "segment:id";
    FovFieldTypes["PrestoredText"] = "page:prestored_text";
    /**
     * Text seen condition used outside PVL.
     *
     * For PVL/SPV, use `FovPageViewLevelFieldTypes.TextConditionFullSearch`
     */
    FovFieldTypes["TextSeen"] = "segment:textSeen";
    FovFieldTypes["VisitText"] = "visit:text";
    FovFieldTypes["IsReturning"] = "visit:isNew";
    FovFieldTypes["NumberVisits"] = "visit:number";
    FovFieldTypes["Language"] = "visitor:language";
    FovFieldTypes["Connection"] = "visit:connectionType";
    FovFieldTypes["AppVersion"] = "visit:appVersion";
    FovFieldTypes["DynamicVariable"] = "dynamicVar";
    FovFieldTypes["DeviceModel"] = "device:manufacturer";
    FovFieldTypes["DeviceModelVersion"] = "device:model";
    FovFieldTypes["OsVersion"] = "device:osVersion";
    FovFieldTypes["Transaction"] = "visit:isBuyer";
    FovFieldTypes["Amount"] = "visit:amount";
    FovFieldTypes["NumberPageViews"] = "visit:pageviews";
    FovFieldTypes["VisitDuration"] = "visit:durationTime";
    FovFieldTypes["Referrer"] = "source:from";
    FovFieldTypes["GeographicCity"] = "location:city";
    FovFieldTypes["GeographicArea"] = "location:country";
    FovFieldTypes["Test"] = "version:id";
    FovFieldTypes["CustomVariable"] = "customVar";
    FovFieldTypes["Browser"] = "browser:name";
    FovFieldTypes["BrowserVersion"] = "browser:version";
    FovFieldTypes["Os"] = "browser:platform";
    FovFieldTypes["WebOsVersion"] = "browser:platformVersion";
    FovFieldTypes["Resolution"] = "browser:resolution";
    FovFieldTypes["LandingPath"] = "visit:landingPath";
    FovFieldTypes["LandingPage"] = "visit:landingPage";
    FovFieldTypes["LandingPagePOF"] = "visit:landingPagePOF";
    FovFieldTypes["ExitPage"] = "visit:exitPath";
    FovFieldTypes["NumberPageviews"] = "visit:pageviews";
    FovFieldTypes["PageHostViewed"] = "page:host";
    FovFieldTypes["PagePathViewed"] = "page:path";
    FovFieldTypes["PageFullUrlViewd"] = "page:fullURL";
    FovFieldTypes["PageQueryParamsViewed"] = "page:query";
    FovFieldTypes["PageEvent"] = "page:pageEvent";
    FovFieldTypes["PageText"] = "page:text";
    /**
     * Full sentence search condition used in Impact module.
     */
    FovFieldTypes["FullText"] = "page:full_text";
    FovFieldTypes["PageCustomHashId"] = "page:customHashId";
    FovFieldTypes["SessionVisitIP"] = "visit:ip";
    FovFieldTypes["SegmentMerch"] = "segment:merch";
    FovFieldTypes["SegmentMerchProduct"] = "segment:merchProduct";
    FovFieldTypes["SegmentMerchCategoryBrand"] = "segment:merchCategoryBrand";
    /**
     * Error condition.
     */
    FovFieldTypes["Error"] = "error";
    FovFieldTypes["ErrorMessage"] = "error:message";
    FovFieldTypes["ErrorFileName"] = "error:filename";
    FovFieldTypes["ErrorLineNumber"] = "error:lineNumber";
    FovFieldTypes["ErrorColumnNumber"] = "error:colNumber";
    FovFieldTypes["ErrorType"] = "error:type";
    FovFieldTypes["ErrorGroupId"] = "error:groupId";
    FovFieldTypes["ApiErrorURL"] = "errorApi:url";
    FovFieldTypes["ApiErrorStatusCode"] = "errorApi:statusCode";
    FovFieldTypes["ApiErrorMethod"] = "errorApi:method";
    FovFieldTypes["ApiErrorType"] = "errorApi:type";
    FovFieldTypes["ApiErrorGroupId"] = "errorApi:groupId";
    FovFieldTypes["ErrorDismissStatus"] = "error:dismiss_status";
    FovFieldTypes["ApiErrorDismissStatus"] = "errorApi:dismiss_status";
    FovFieldTypes["CustomErrorType"] = "customError:type";
    FovFieldTypes["CustomErrorMessage"] = "customError:message";
    FovFieldTypes["CustomErrorAttributes"] = "customError:attributes";
    FovFieldTypes["CustomErrorGroupId"] = "customError:groupId";
    /**
     ********************
     */
    FovFieldTypes["ExcludeBots"] = "visit:excludeBots";
    FovFieldTypes["IsBot"] = "visit:isBot";
    FovFieldTypes["SdkScreenActivity"] = "screen:activity";
    FovFieldTypes["SdkScreenContainer"] = "screen:container";
    FovFieldTypes["SdkScreenQuery"] = "screen:query";
    FovFieldTypes["SdkScreenName"] = "screen:name";
    FovFieldTypes["LargestContentfulPaint"] = "cwv:largest_contentful_paint";
    FovFieldTypes["FirstContentfulPaint"] = "cwv:first_contentful_paint";
    FovFieldTypes["CumulativeLayoutShift"] = "cwv:cumulative_layout_shift";
    FovFieldTypes["FirstInputDelay"] = "cwv:first_input_delay";
    FovFieldTypes["TimeToFirstByte"] = "cwv:time_to_first_byte";
    FovFieldTypes["EnrichmentIntegration"] = "external:integrationEnrichment";
    /**
     * Accessibility
     */
    FovFieldTypes["AccessibilityFeatures"] = "accessibility:features";
    FovFieldTypes["AccessibilityZoom"] = "accessibility:zoom";
    FovFieldTypes["AccessibilityHighlight"] = "accessibility:highlight";
    FovFieldTypes["AccessibilityKeyboard"] = "accessibility:keyboard";
    FovFieldTypes["AccessibilityKeyboardClick"] = "accessibility:keyboard_click";
    FovFieldTypes["AccessibilityKeyboardFocus"] = "accessibility:keyboard_focus";
    FovFieldTypes["AccessibilityKeyboardScroll"] = "accessibility:keyboard_scroll";
})(FovFieldTypes || (FovFieldTypes = {}));
export var FovPageViewLevelFieldTypes;
(function (FovPageViewLevelFieldTypes) {
    /**
     * Zone Interaction conditions
     */
    FovPageViewLevelFieldTypes["ZoneInteractionClick"] = "pageview:zone-interaction:click";
    FovPageViewLevelFieldTypes["ZoneInteractionHover"] = "pageview:zone-interaction:hover";
    FovPageViewLevelFieldTypes["ZoneInteractionTap"] = "pageview:zone-interaction:tap";
    FovPageViewLevelFieldTypes["ZoneInteractionExitZone"] = "pageview:zone-interaction:exitZone";
    /**
     * TextSeens
     */
    FovPageViewLevelFieldTypes["TextConditionFullSearch"] = "pageview:fullSearch";
    /**
     * Zone Metrics
     */
    FovPageViewLevelFieldTypes["MetricHoverTime"] = "metric:hoverTime";
    FovPageViewLevelFieldTypes["MetricTimeBeforeFirstClick"] = "metric:timeBeforeFirstClick";
    FovPageViewLevelFieldTypes["MetricHesitationTime"] = "metric:hesitationTime";
    /**
     * Pageview Metrics
     */
    FovPageViewLevelFieldTypes["MetricScrollRate"] = "metric:scrollRate";
    FovPageViewLevelFieldTypes["MetricTimeSpent"] = "metric:timeSpent";
    /**
     * Frontend conditions (Not usable by DT)
     */
    FovPageViewLevelFieldTypes["FrontendZoneInteractionGoal"] = "frontend:pageview:zone-interaction:goal";
    /**
     * PageEvent conditions
     */
    FovPageViewLevelFieldTypes["PageEvent"] = "page:pageEvent";
})(FovPageViewLevelFieldTypes || (FovPageViewLevelFieldTypes = {}));
export var ActionType;
(function (ActionType) {
    ActionType["Click"] = "click";
    ActionType["Change"] = "change";
    ActionType["Focus"] = "focus";
    ActionType["Tap"] = "tap";
    ActionType["Pageview"] = "pageview";
    ActionType["Screenview"] = "screenview";
    ActionType["PageEvent"] = "pageEvent";
    ActionType["Hover"] = "hover";
    ActionType["HoverTime"] = "hoverTime";
    ActionType["ExitPage"] = "exitPage";
    ActionType["ExitZone"] = "exitZone";
    ActionType["Purchase"] = "purchase";
    ActionType["AddToCart"] = "addToCart";
    ActionType["MetricBounce"] = "metric:bounce";
    ActionType["MetricScrollRate"] = "metric:scrollRate";
    ActionType["MetricTimeBeforeFirstClick"] = "metric:timeBeforeFirstClick";
    ActionType["MetricHesitationTime"] = "metric:hesitationTime";
    ActionType["MetricHoverTime"] = "metric:hoverTime";
    ActionType["MetricTimeSpent"] = "metric:timeSpent";
    ActionType["MetricClickRepetition"] = "metric:clickRepetition";
    ActionType["RageClick"] = "friction:rageClick";
    ActionType["QualifiedBouncers"] = "friction:qualifiedBouncers";
    ActionType["MultiplePageRevisit"] = "friction:multiplePageRevisit";
    ActionType["MultipleButtonInteraction"] = "friction:multipleButtonInteraction";
    ActionType["MultipleFieldInteraction"] = "friction:multipleFieldInteraction";
    ActionType["LoadingTime"] = "friction:loadingTime";
    ActionType["PromocodeStruggle"] = "friction:promocodeStruggle";
})(ActionType || (ActionType = {}));
export var FovNodeTypes;
(function (FovNodeTypes) {
    FovNodeTypes["AND"] = "AND";
    FovNodeTypes["OR"] = "OR";
    FovNodeTypes["NOT"] = "NOT";
    FovNodeTypes["SEQ"] = "SEQ";
    FovNodeTypes["CSEQ"] = "CSEQ";
    FovNodeTypes["DIRECTLY_THEN"] = "DIRECTLY_THEN";
    FovNodeTypes["FILTER"] = "filter";
})(FovNodeTypes || (FovNodeTypes = {}));
export var FovValueOperator;
(function (FovValueOperator) {
    FovValueOperator["EQUAL"] = "=";
    FovValueOperator["GREATER"] = ">";
    FovValueOperator["LESS"] = "<";
    FovValueOperator["GREATER_OR_EQUAL"] = ">=";
    FovValueOperator["LESS_OR_EQUAL"] = "<=";
    FovValueOperator["NOT_EQUAL"] = "!=";
    FovValueOperator["BETWEEN"] = "between";
})(FovValueOperator || (FovValueOperator = {}));
export var FovPageType;
(function (FovPageType) {
    FovPageType["ANY"] = "any";
    FovPageType["URL"] = "url";
    FovPageType["PAGE"] = "page";
})(FovPageType || (FovPageType = {}));
export var FovErrorOption;
(function (FovErrorOption) {
    FovErrorOption["ANY"] = "any";
    FovErrorOption["NAMED"] = "named";
    FovErrorOption["EXACT"] = "exact";
    FovErrorOption["GROUPED"] = "grouped";
})(FovErrorOption || (FovErrorOption = {}));
export var FovErrorType;
(function (FovErrorType) {
    FovErrorType["API"] = "API";
    FovErrorType["JS"] = "JS";
    FovErrorType["CUSTOM"] = "CUSTOM";
})(FovErrorType || (FovErrorType = {}));
export var HttpMethods;
(function (HttpMethods) {
    HttpMethods["GET"] = "GET";
    HttpMethods["POST"] = "POST";
    HttpMethods["PUT"] = "PUT";
    HttpMethods["PATCH"] = "PATCH";
    HttpMethods["DELETE"] = "DELETE";
})(HttpMethods || (HttpMethods = {}));
export var FovErrorExperience;
(function (FovErrorExperience) {
    FovErrorExperience["EXPERIENCED"] = "EXPERIENCED";
    FovErrorExperience["HAVE_NOT_EXPERIENCED"] = "HAVE_NOT_EXPERIENCED";
})(FovErrorExperience || (FovErrorExperience = {}));
export var FovErrorStatusOptions;
(function (FovErrorStatusOptions) {
    FovErrorStatusOptions["ALL"] = "ALL";
    FovErrorStatusOptions["DISMISSED"] = "DISMISSED";
    FovErrorStatusOptions["UNDISMISSED"] = "UNDISMISSED";
})(FovErrorStatusOptions || (FovErrorStatusOptions = {}));
// tslint:disable-next-line: variable-name
export const FovGroupTypes = Object.freeze([
    FovNodeTypes.AND,
    FovNodeTypes.OR,
    FovNodeTypes.SEQ,
    FovNodeTypes.CSEQ,
    FovNodeTypes.DIRECTLY_THEN,
]);
export const FOV_EMPTY = {
    children: [],
    nodeType: FovNodeTypes.AND,
};
export const FOV_ALL_VISITORS = {
    nodeType: FovNodeTypes.FILTER,
    field: FovFieldTypes.SegmentId,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: -1,
};
export var FovGoalEmerchType;
(function (FovGoalEmerchType) {
    FovGoalEmerchType["Model"] = "model";
    FovGoalEmerchType["Product"] = "product";
    FovGoalEmerchType["Category"] = "category";
    FovGoalEmerchType["Brand"] = "brand";
})(FovGoalEmerchType || (FovGoalEmerchType = {}));
export var FovPageViewLevelVisitType;
(function (FovPageViewLevelVisitType) {
    FovPageViewLevelVisitType["Visit"] = "pageview:visit";
    FovPageViewLevelVisitType["First"] = "pageview:first";
    FovPageViewLevelVisitType["Last"] = "pageview:last";
    FovPageViewLevelVisitType["Bounce"] = "pageview:bounce";
    /**
     * It'll be converted as `FovPageViewLevelVisitType.Visit` and use corresponding goal's page.
     * Goal need to be `type="pageview"`.
     */
    FovPageViewLevelVisitType["FrontendGoal"] = "frontend:pageview:goal";
})(FovPageViewLevelVisitType || (FovPageViewLevelVisitType = {}));
export const GOAL_ANY_PAGE = {
    field: 'pageview:no_op',
    nodeType: FovNodeTypes.FILTER,
    operator: '',
};
//# sourceMappingURL=fov-models.js.map